module.exports = __webpack_public_path__ + "media/images/svg/exchange-074eddc4fc3315cefdfc6a6cfe2663de.svg";